import { h, Component } from 'preact'
import parser from './DocumentParser'

interface Props {
  liveEdit?: boolean
}

interface State {
  cssClass: string
  category?: string
  message?: string
  translation?: string
}

function isKeyboardEvent (e: {keyCode?: number, target: unknown}): e is {keyCode: number, target: {value: string}} {
  if (typeof e !== 'object' || e === null) return false
  if (typeof e.target !== 'object' || e.target === null) return false
  return 'value' in e.target
}

export default class TranslationForm extends Component<Props, State> {
  textInput?: HTMLInputElement

  constructor (props: Props) {
    super(props)
    this.state = {
      cssClass: 'live-edit__form'
    }

    this.onPhraseGetStart = this.onPhraseGetStart.bind(this)
    this.onPhraseGetEnd = this.onPhraseGetEnd.bind(this)
    this.onTranslateEnd = this.onTranslateEnd.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  // interface for DocumentParser
  onPhraseGetStart () {
    this.setState(Object.assign(this.state, {
      cssClass: 'live-edit__form loading'
    }))
  }

  onPhraseGetEnd (data: State) {
    this.setState(Object.assign({
      cssClass: 'live-edit__form active'
    }, data))
    this.textInput?.focus()
  }

  onTranslateEnd (data: State) {
    this.setState(Object.assign({
      cssClass: 'live-edit__form done'
    }, data))
  }

  handleClose () {
    this.setState(Object.assign(this.state, {
      cssClass: 'live-edit__form'
    }))
  }

  handleSubmit (e: Event) {
    e.preventDefault()

    this.setState(Object.assign(this.state, {
      cssClass: 'live-edit__form sending'
    }), () => {
      parser.translate(this.state)
    })
  }

  handleChange (e: Event) {
    if (!isKeyboardEvent(e)) return
    this.setState(Object.assign(this.state, {
      translation: e?.target?.value
    }))
  }

  handleKeyDown (e: Event) {
    if (!isKeyboardEvent(e)) return
    if (e.keyCode === 27) {
      this.handleClose()
    }
  }

  componentDidMount () {
    if (this.props.liveEdit) {
      parser.init(this.onPhraseGetStart, this.onPhraseGetEnd, this.onTranslateEnd)
      document.addEventListener('keydown', this.handleKeyDown)
    }
  }

  componentWillUnmount () {
    if (this.props.liveEdit) {
      parser.exit()
    }
    document.removeEventListener('keydown', this.handleKeyDown)
  }

  render () {
    const { cssClass, category, message, translation } = this.state

    return (
      <form class={cssClass}>
        <button type='button' onClick={this.handleClose} class='btn--cta btn--close icon--cross' title='Hide panel (<esc>)' />
        <label>
          <strong>Category</strong> <em>{category}</em> - <strong>Phrase</strong> <em>{message}</em>
        </label>
        <div class='live-edit__form__inputs'>
          <input type='text' value={translation} ref={input => { this.textInput = input }} onChange={this.handleChange} />
          <button type='submit' onClick={this.handleSubmit} class='btn--cta' title='Save (<enter>)'>Save</button>
        </div>
      </form>
    )
  }
}
